import { render } from "./CrumbsMenu.vue?vue&type=template&id=1296ed39"
import script from "./CrumbsMenu.vue?vue&type=script&lang=js"
export * from "./CrumbsMenu.vue?vue&type=script&lang=js"

import "./CrumbsMenu.vue?vue&type=style&index=0&id=1296ed39&lang=scss"
script.render = render

export default script